import _ from 'lodash';
import { type HeaderService } from '@patsnap-utils/biz';
import { Site, SLD } from '@patsnap-utils/biz';
import '@patsnap-ui/icon/assets/solid/users.svg';
import '@patsnap-ui/icon/assets/solid/conversation.svg';
import '@patsnap-ui/icon/assets/solid/HelpCentre.svg';
import '@patsnap-ui/icon/assets/Term.svg';
import '@patsnap-ui/icon/assets/Privacy.svg';

interface HelpItem {
    icon: string;
    label: string;
    href: string;
}

const messages: Record<string, unknown> = {
    cn: {
        help: {
            helpCenter: '帮助中心',
            startVideos: '入门视频',
            patsnapCommunity: '交流社区',
            searchHelper: '搜索帮助',
            releaseLog: '更新日志',
            dataCoverage: '数据范围',
            askForHelp: '需要帮助',
            terms: '服务条款',
            policy: '隐私政策',
        },
    },
    en: {
        help: {
            helpCenter: 'Help center',
            startVideos: 'Video Guides',
            patsnapCommunity: 'Community',
            searchHelper: 'Search Helper',
            releaseLog: 'Release Log',
            dataCoverage: 'Data Coverage',
            askForHelp: 'Ask for Help',
            terms: 'Terms of Service',
            policy: 'Privacy Policy',
        },
    },
    jp: {
        help: {
            helpCenter: 'ヘルプ',
            startVideos: '入門ビデオ',
            patsnapCommunity: 'オンラインコミュニティ',
            searchHelper: '検索ヘルプ',
            releaseLog: 'リリース履歴',
            dataCoverage: 'データ収録範囲',
            askForHelp: 'お問合せ',
            terms: 'サービス条項',
            policy: 'プライバシーポリシー',
        },
    },
    tw: {
        help: {
            helpCenter: '幫助中心',
            startVideos: '入門視頻',
            patsnapCommunity: '交流社區',
            searchHelper: '搜索幫助',
            releaseLog: '更新日志',
            dataCoverage: '數據範圍',
            askForHelp: '需要幫助',
            terms: '服務條款',
            policy: '隱私政策',
        },
    },
};

const linkMap = {
    east: {
        helpCenter: 'https://help.zhihuiya.com/help/analytics',
        videoGuide: '',
        community: 'https://talk.zhihuiya.com/new_index',
        searchHelper: 'https://analytics.zhihuiya.com/telecom#/helper',
        releaseLog: 'https://help.zhihuiya.com/help/360007923512/article/900000548043?categoryId=360002609831',
        dataCoverage: 'https://analytics.zhihuiya.com/status',
        askForHelp: '',
        terms: 'https://www.zhihuiya.com/legal/terms',
        privacy: 'https://www.zhihuiya.com/legal/privacy',

    },
    west: {
        helpCenter: 'https://help.patsnap.com/hc/en-us',
        videoGuide: 'https://help.patsnap.com/hc/en-us/sections/8496364813213-Video-Guides',
        community: 'https://help.patsnap.com/hc/en-us/community/topics',
        searchHelper: 'https://analytics.patsnap.com/telecom#/helper',
        releaseLog: 'https://help.patsnap.com/hc/en-us/sections/8496364103837-What-s-New',
        dataCoverage: 'https://analytics.patsnap.com/status',
        askForHelp: 'https://patsnap.zendesk.com/agent/',
        terms: 'https://www.patsnap.com/legal/',
        privacy: 'https://www.patsnap.com/legal/privacy-policy/',

    },
};

const getHelpCenter = (i18n: any, headerService: HeaderService) => {
    const isCn = headerService?.account?.siteRegion === 'CN';
    const linkMapInfo = isCn ? linkMap.east : linkMap.west;

    Object.keys(messages).forEach(locale => i18n.mergeLocaleMessage(locale, messages[locale]));
    let helpItems : (HelpItem | null)[] = [{ icon: 'SolidHelpCentre', label: i18n.t('help.helpCenter'), href: linkMapInfo.helpCenter }];
    if (isCn) {
        helpItems = _.concat(helpItems, [
            { icon: 'SolidUsers', label: i18n.t('help.patsnapCommunity'), href: linkMapInfo.community },
            { icon: 'SolidSearchLeft', label: i18n.t('help.searchHelper'), href: linkMapInfo.searchHelper },
            { icon: 'SolidCalendar7', label: i18n.t('help.releaseLog'), href: linkMapInfo.releaseLog },
            { icon: 'SolidGlobal', label: i18n.t('help.dataCoverage'), href: linkMapInfo.dataCoverage },
        ]);
    } else {
        helpItems = _.concat(helpItems, [
            { icon: 'SolidVideoExist', label: i18n.t('help.startVideos'), href: linkMapInfo.videoGuide },
            { icon: 'SolidUsers', label: i18n.t('help.patsnapCommunity'), href: linkMapInfo.community },
            { icon: 'SolidSearchLeft', label: i18n.t('help.searchHelper'), href: linkMapInfo.searchHelper },
            { icon: 'SolidCalendar7', label: i18n.t('help.releaseLog'), href: linkMapInfo.releaseLog },
            { icon: 'SolidGlobal', label: i18n.t('help.dataCoverage'), href: linkMapInfo.dataCoverage },
            { icon: 'SolidConversation', label: i18n.t('help.askForHelp'), href: linkMapInfo.askForHelp },
        ]);
    }

    helpItems = _.concat(helpItems, [
        null,
        { icon: 'Term', label: i18n.t('help.terms'), href: linkMapInfo.terms },
        { icon: 'Privacy', label: i18n.t('help.policy'), href: linkMapInfo.privacy },
    ]);

    if (!headerService.right) headerService.right = [];

    headerService.right = _.concat(headerService.right, [{
        icon: 'HelpCenter',
        trigger: 'hover',
        menu: helpItems,
    }]);
};

export {
    getHelpCenter,
};
